import { useMemo } from "react";
import { toSafeHtml } from "@/utils/sanitizeHtml";

type SafeHtmlTag = "div" | "p" | "span" | "section" | "article";

interface SafeHtmlProps {
  /** Raw CMS / database content. HTML is sanitised, plain text keeps line breaks. */
  html?: string | null;
  className?: string;
  as?: SafeHtmlTag;
  id?: string;
}

/**
 * The ONLY approved way to render CMS / database content as markup.
 *
 * It funnels the string through the DOMPurify allow-list in
 * `utils/sanitizeHtml` before it ever reaches the DOM, so untrusted content
 * (listing descriptions, content blocks, advert copy) can never inject a script
 * or event handler. Prefer this over a bare dangerouslySetInnerHTML.
 */
export default function SafeHtml({ html, className, as: Tag = "div", id }: SafeHtmlProps) {
  const clean = useMemo(() => toSafeHtml(html), [html]);
  if (!clean) return null;
  return <Tag id={id} className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}